import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import SuccessModal from "../../SuccessModal";
import { customerUpdate } from "../../../services/CustomerInfo/EditCustomer";
import { getStoreLocalData } from "../../../utils/localStorage";

export default function EditCustomerModal({
  editCustomerModalVisible,
  setEditCustomerModalVisible,
  fieldName, // Receive the field name from EditCustomer
  fieldValue, // Receive the field value from EditCustomer
  editIcon,
  editCustomerData,
  sendDataToEditCustomer,
  enabledAddInternationalCustomer,
  //   handleEditData, // Function to handle edit in EditCustomer
}) {
  const navigate = useNavigate();

  const [editValue, setEditValue] = useState(fieldValue);

  const { storeLocalData } = getStoreLocalData();
  const countryCode = storeLocalData?.countryCode;

  const [errorMessage, setErrorMessage] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [gstError, setGstError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [switchCustomerType, setSwitchCustomerType] = useState(false)

  // const validateMobile = (text) => {
  //   let isValid = true;
  //   if (/^[56789]\d{9}$/.test(text) || text === "") {
  //     setErrorMessage("");
  //     isValid = true;
  //   } else {
  //     setErrorMessage("Please enter a valid 10-digit mobile number. That start with no. 5678 or 9");
  //     isValid = false;
  //   }

  //   return isValid;
  // };

  const validateMobile = (text) => {


    let isValid = true;

    // Remove country code from entered value if already included
    let number = text;

    if (countryCode && text.startsWith(countryCode)) {
      number = text.replace(countryCode, "").trim();
    }

    let isValidFull = false;

    // Validation based on country code
    if (countryCode === "+91") {
      // India: starts with 5-9 and exactly 10 digits
      isValidFull = /^[5-9]\d{9}$/.test(number) || number === "";

    } else if (countryCode === "+971") {
      // UAE: starts with 5 and exactly 9 digits
      isValidFull = /^5\d{8}$/.test(number) || number === "";

    } else {
      // Default validation (optional fallback)
      isValidFull = /^\d{6,15}$/.test(number) || number === "";
    }

    if (isValidFull) {
      setErrorMessage("");
      isValid = true;
    } else {
      setErrorMessage(
        countryCode === "+91"
          ? "Please enter a valid 10-digit Indian number starting with 5-9."
          : countryCode === "+971"
            ? "Please enter a valid 9-digit mobile number starting with 5."
            : "Please enter a valid mobile number."
      );

      isValid = false;
    }

    return isValid;
  };

  const validateGST = (text) => {
    let isValid = true;
    if (
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(text) ||
      text === ""
    ) {
      setErrorMessage("");
      isValid = true;
    } else {
      setErrorMessage("Please enter a valid " + storeLocalData?.taxType + "number");
      isValid = false;
    }
    return isValid;
  };

  const validateEmail = (text) => {
    // You can use a regular expression or a more complex email validation logic here
    // This is a simple example
    let isValid = true;
    if (/\S+@\S+\.\S+/.test(text) || text === "") {
      setErrorMessage("");
      isValid = true;
    } else {
      setErrorMessage("Please enter a valid email address");
      isValid = false;
    }
    return isValid;
  };

  const handleEditChange = (text) => {
    if (fieldName === "Mobile No.") {
      validateMobile(text);
      setEditValue(text);
    } else if (fieldName === "GST") {
      validateGST(text);
      setEditValue(text);
    } else if (fieldName === "Email") {
      validateEmail(text);
      setEditValue(text);
    }
  };

  const validateInputs = (text) => {
    let isValidConfirm = false;
    if (fieldName === "Mobile No." && validateMobile(text)) {
      isValidConfirm = true;
    }
    if (fieldName === storeLocalData?.taxType && validateGST(text)) {
      isValidConfirm = true;
    }
    if (fieldName === "Email" && validateEmail(text)) {
      isValidConfirm = true;
    }
    return isValidConfirm;
  };

  const handleEditData = async () => {
    // Create a new edited field object
    if (validateInputs(editValue)) {
      const editedField = {
        fieldName: fieldName, // Store the field name
        fieldValue: editValue, // Store the edited field value
        customerType: "customerType",
      };

      // Update the specific field in editCustomerData
      let updatedData = { ...editCustomerData };
      if (fieldName === "Email") {
        updatedData.brandCustomer.email = editValue;
        updatedData.brandCustomer.customerType = "customerType";
      } else if (fieldName === "Mobile No.") {
        updatedData.brandCustomer.mobile = countryCode + editValue;
        updatedData.brandCustomer.customerType = "customerType";
      } else if (fieldName === storeLocalData?.taxType) {
        updatedData.brandCustomer.gstNo = editValue;
        updatedData.brandCustomer.customerType = "customerType";
      }
      // Add more conditions for other fields
      try {
        const response = await customerUpdate(updatedData);
        if (!response.data.error) {
          const Res = response.data;
          const message = Res.message;
          const status = Res.status;
          // Close the modal
          setEditCustomerModalVisible(false);

          sendDataToEditCustomer({
            success: true,
          });
          if (status === true) {
            setModalVisible(true);
            setModalStatus("success");
            setModalText(message);
          } else {
            setModalVisible(true);
            setModalStatus("not Success");
            setModalText(message);
          }
          // if (Res) {
          //   sendDataToEditCustomer({
          //     success: true,
          //   });
          // }
          setErrorMessage("");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const handleInternationalNumberEditData = async () => {

    // Update the specific field in editCustomerData
    let updatedData = { ...editCustomerData };
    updatedData.brandCustomer.mobile = editValue;
    updatedData.brandCustomer.customerType = "customerType";
    // Add more conditions for other fields
    try {
      const response = await customerUpdate(updatedData);
      if (!response.data.error) {
        const Res = response.data;
        const message = Res.message;
        const status = Res.status;
        // Close the modal
        setEditCustomerModalVisible(false);

        sendDataToEditCustomer({
          success: true,
        });
        if (status === true) {
          setModalVisible(true);
          setModalStatus("success");
          setModalText(message);
        } else {
          setModalVisible(true);
          setModalStatus("not Success");
          setModalText(message);
        }
        // if (Res) {
        //   sendDataToEditCustomer({
        //     success: true,
        //   });
        // }
        setErrorMessage("");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    // When the fieldName or fieldValue changes, update the editValue
    if (fieldName !== null && fieldValue !== null) {
      if (fieldName === "Mobile No.") {
        let number = fieldValue;

        if (countryCode && fieldValue.startsWith(countryCode)) {
          number = fieldValue.replace(countryCode, "").trim();
        }
        setEditValue(number);
      } else {
        setEditValue(fieldValue);
      }
    }
  }, [fieldName, fieldValue]);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleModalClose = () => {
    setErrorMessage("");
    setEditCustomerModalVisible(false);
    setSwitchCustomerType(false)
    // setEditValue
    // setEditLastNameValue
  };

  const handleAddInternationalCustomer = () => {
    setSwitchCustomerType(!switchCustomerType)
  }

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={editCustomerModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!editCustomerModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              {editIcon}
              <p className=" text-4xl text-primary-50 font-semibold">
                Edit {fieldName}
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div className="inline-flex flex-column gap-2 mx-4">
              <p className=" font-semibold">{switchCustomerType ? "International " : ""}{fieldName}</p>
              <InputText
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                id="firstName"
                label="firstName"
                placeholder={`Enter ${fieldName}`}
                className="bg-white-alpha-20 border-round-xl p-2 text-xl "
              ></InputText>
              {errorMessage && <p className="text-md font-semibold" style={{ color: "red" }}>{errorMessage}</p>}
            </div>

            {switchCustomerType && (
              <p
                className=" text-lg font-medium capitalize ml-2 mt-2"
                style={{ color: "blue" }}
              >
                Please enter International number with country code
                +9198xxxxxxxx
              </p>
            )}

            <Button
              onClick={
                switchCustomerType
                  ? handleInternationalNumberEditData
                  : handleEditData
              }
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Submit
              </p>
            </Button>

            {enabledAddInternationalCustomer && fieldName === "Mobile No."  && (
              <div className="flex justify-content-center align-items-center flex-1 cursor-pointer mb-3">
                <p
                  className=" text-lg font-medium capitalize ml-2 text-center"
                  style={{ color: "blue" }}
                  onClick={() => handleAddInternationalCustomer()}
                >
                  {!switchCustomerType
                    ? "Edit International Number"
                    : "Edit National Number"}{" "}
                  <i
                    className="pi pi-plus"
                    style={{
                      fontSize: "15px",
                      cursor: "pointer",
                      color: "blue",
                    }}
                  ></i>
                </p>
              </div>
            )}
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
}
